// src/components/BattleScreen/BattleAnimations/VineWhipAnimation.jsx
import { useEffect } from "react";
import "./VineWhipAnimation.css";

export default function VineWhipAnimation({ playerRef, opponentRef, onComplete }) {
  useEffect(() => {
    const playerEl   = playerRef.current;
    const opponentEl = opponentRef.current;
    if (!playerEl || !opponentEl) return;

    const container = playerEl.closest(".battle-bg");
    const pRect     = playerEl.getBoundingClientRect();
    const oRect     = opponentEl.getBoundingClientRect();
    const cRect     = container.getBoundingClientRect();

    const containerX = cRect.left;
    const containerY = cRect.top;

    // Top-left (non-centered) positions for .vine-main
    const startX = pRect.left - containerX;
    const startY = pRect.top - containerY;
    const endX   = oRect.left - containerX;
    const endY   = oRect.top - containerY;

    const flightDuration = 500;
    const impactDuration = 400;
    const delayStep      = 60;

    const vines = [];

    for (let i = 0; i < 3; i++) {
      const vine = document.createElement("div");
      vine.className = "vine-main";
      vine.style.left           = `${startX}px`;
      vine.style.top            = `${startY}px`;
      vine.style.animationDelay = `${i * delayStep}ms`;

      // offset each slightly
      const dx = (endX - startX) + (i - 1) * 6;
      const dy = (endY - startY) + (Math.random() * 16 - 8);
      vine.style.setProperty("--dx", `${dx}px`);
      vine.style.setProperty("--dy", `${dy}px`);

      container.appendChild(vine);
      vines.push(vine);

     vine.addEventListener("animationend", function onFlight(e) {
  if (e.animationName === "vineWhipFlight") {
    // Move to opponent's center before impact
    vine.style.left = `${endX}px`;
    vine.style.top  = `${endY}px`;
    vine.style.transform = 'none'; // Reset any old transform
    vine.classList.add("impact");
    vine.removeEventListener("animationend", onFlight);
  }
});


      vine.addEventListener("animationend", function onImpact(e) {
        if (e.animationName === "vineImpactFrames") {
          vine.removeEventListener("animationend", onImpact);
          vine.remove();
        }
      });
    }

    const totalTime = ((3 - 1) * delayStep + flightDuration + impactDuration);

    const timeout = setTimeout(() => {
      const burst = document.createElement("div");
      burst.className = "vine-impact-burst";
      burst.style.left = `${endX + oRect.width / 2}px`;
      burst.style.top  = `${endY + oRect.height / 2}px`;
      container.appendChild(burst);

      // Directly apply hit effect to opponent
      opponentEl.classList.add("vine-hit");
      setTimeout(() => opponentEl.classList.remove("vine-hit"), 300);

      setTimeout(() => burst.remove(), impactDuration);
      onComplete();
    }, totalTime);

    return () => {
      clearTimeout(timeout);
      vines.forEach(v => v.remove());
    };
  }, [playerRef, opponentRef, onComplete]);

  return null;
}

VineWhipAnimation.moveType = "grass";
